
  function MarqueeLeft(selector, speed) {
    const parentSelector = document.querySelector(selector);
    const clone = parentSelector.innerHTML;
    const firstElement = parentSelector.children[0];
    let i = 0;
    let interval;

    parentSelector.insertAdjacentHTML('beforeend', clone);

    function startMarquee() {
      interval = setInterval(function () {
        firstElement.style.marginLeft = `-${i}px`;
        if (i > firstElement.clientWidth) {
          i = 0;
        }
        i = i + speed;
      }, 10);
    }

    function stopMarquee() {
      clearInterval(interval);
    }

    // Start marquee on load
    startMarquee();

    // Pause on hover
    parentSelector.addEventListener("mouseenter", stopMarquee);
    parentSelector.addEventListener("mouseleave", startMarquee);
  }


  function MarqueeRight(selector, speed) {
    const parentSelector = document.querySelector(selector);
    const clone = parentSelector.innerHTML;
    const firstElement = parentSelector.children[0];
    let i = 0; // Start offscreen (left side)
    let interval;

    parentSelector.insertAdjacentHTML('beforeend', clone);

    function startMarquee() {
      interval = setInterval(function () {
        firstElement.style.marginLeft = `${i}px`;

        if (i >= 0) {
          i = -firstElement.clientWidth; // Reset position when fully visible
        }
        i = i + speed; // Move right
      }, 10);
    }

    function stopMarquee() {
      clearInterval(interval);
    }

    // Start marquee on load
    startMarquee();

    // Pause on hover
    parentSelector.addEventListener("mouseenter", stopMarquee);
    parentSelector.addEventListener("mouseleave", startMarquee);
  }


  window.addEventListener('load', function(){
    MarqueeLeft('.marquee', 0.2);
    MarqueeRight('.marquee1', 0.2);
  });